// extracted by mini-css-extract-plugin
export default {"NotificationList":"NotificationList_NotificationList__bLWLV","toggleBtnText":"NotificationList_toggleBtnText__92CsC"};